import { Tile } from '@timeflies/tilemap-utils';
import { AnimatedSprite as PixiAnimatedSprite } from 'pixi.js';
import React from 'react';
import { Container, CustomPIXIComponent, Sprite } from 'react-pixi-fiber';
import { textureFromIdGetter } from './utils/texture-from-id-getter';
import { tileInfosGetter } from './utils/tile-infos-getter';
var AnimatedSprite = CustomPIXIComponent({
    customDisplayObject: function (_a) {
        var frameObjects = _a.frameObjects;
        var sprite = new PixiAnimatedSprite(frameObjects, true);
        sprite.play();
        return sprite;
    }
}, 'AnimatedSprite');
export var TilemapTile = function (_a) {
    var id = _a.id, index = _a.index, mapSheet = _a.mapSheet, mapTexture = _a.mapTexture, onTileMouseHover = _a.onTileMouseHover, layer = _a.layer, interactive = _a.interactive;
    var _b = React.useState(false), touchStarted = _b[0], setTouchStarted = _b[1];
    var getTextureFromId = textureFromIdGetter({ mapSheet: mapSheet, mapTexture: mapTexture });
    var getTileInfos = tileInfosGetter({ mapSheet: mapSheet, layer: layer });
    var tileInfos = getTileInfos(id, index);
    if (!tileInfos) {
        return null;
    }
    var tileset = tileInfos.tileset, tilePos = tileInfos.tilePos, worldPos = tileInfos.worldPos;
    var texture = getTextureFromId(id, tileset);
    var tilewidth = tileset.tilewidth, tileheight = tileset.tileheight;
    var animationFrameObjects = Tile.getTileAnimation(id, tileset);
    var sprite = animationFrameObjects
        ? React.createElement(AnimatedSprite, { frameObjects: animationFrameObjects.map(function (_a) {
                var tileid = _a.tileid, duration = _a.duration;
                return ({
                    texture: getTextureFromId(tileid, tileset),
                    time: duration
                });
            }) })
        : React.createElement(Sprite, { texture: texture, width: tilewidth, height: tileheight });
    var triggerHover = function () {
        onTileMouseHover(tilePos);
    };
    return React.createElement(Container, { x: worldPos.x, y: worldPos.y, interactive: interactive, mouseover: triggerHover, touchstart: function () {
            setTouchStarted(true);
            triggerHover();
        }, touchend: function () {
            setTouchStarted(false);
        }, touchmove: function (e) {
            var _a = e.currentTarget.transform.worldTransform, scale = _a.a, tx = _a.tx, ty = _a.ty;
            var p = e.data.global;
            var isInTileBounds = p.x >= tx && p.x < tx + tilewidth * scale
                && p.y >= ty && p.y < ty + tileheight * scale;
            if (touchStarted && !isInTileBounds) {
                setTouchStarted(false);
                onTileMouseHover(null);
            }
        } }, sprite);
};
